import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const PurchaseOrderManageTransactionWrapper = styled.div`
  .current-po-amount {
    background-color: ${COLORS.cirrus_black2};
    padding: 16px;
  }

  .transaction-amount {
    max-width: 55%;
    word-break: break-word;

    ${responsive.MOBILE`
      max-width: 100%;
      padding: 0px 16px 0px 16px;
    `}
  }

  .transaction-type {
    margin: 16px 16px 8px 16px;
    width: 50%;
    ${responsive.MOBILE`
      width: 100%;
      margin: 16px 0;
    `}
  }

  .transaction-type-radio {
    ${responsive.MOBILE`
      padding: 0px 16px 16px 16px;
    `}
  }

  .amount-input {
    margin-right: 16px;
  }

  .balance-po-amount {
    margin-top: 8px;
    ${responsive.MOBILE`
      margin-top: 0px;
      padding: 8px 16px 0px 16px;
    `}
  }

  .transaction-table {
    margin-top: 34px;

    ${responsive.MOBILE`
      margin-top: 0;
    `}
  }

  .transaction-type-grid {
    display: flex;
    align-items: end;
    margin-top: 24px;

    ${responsive.MOBILE`
      flex-direction: column;
      align-items: stretch;
      gap: 16px;
      margin-top: 0px;
    `}
  }

  .transaction-button {
    margin-left: 16px;

    ${responsive.MOBILE`
      margin-left: 0;
      width: 100%;
      padding: 0px 16px 16px 16px;
    `}
  }

  .MuiTablePagination-root {
    visibility: hidden;
  }
  .submit-button {
    width: 130px;

    ${responsive.MOBILE`
      width: 100%;
    `}
  }
`;
